import React from 'react';
import { formatCost } from 'utils/format';

const ConfirmationPlanInfo = ({ application }) => {
    return (
        <div className="review-title review-plan">
            <ul className="no-bullet">
                <li>
                    <p className="review-title">
                        {application.page2['plan']}{' '}
                    </p>
                </li>
                {application.page2.optionalPlanSummary && (
                    <>
                        <li>
                            <p className="review-title">
                                {
                                    application.page2.optionalPlanSummary
                                        .planName
                                }{' '}
                            </p>
                        </li>
                        <li>
                            Total Monthly Premium:{' '}
                            {formatCost(
                                parseFloat(
                                    application.page2.optionalPlanSummary
                                        .premiumAmount
                                ) +
                                    parseFloat(
                                        application.page2.planSummary
                                            .premiumAmount
                                    )
                            )}
                        </li>
                    </>
                )}
            </ul>
        </div>
    );
};

export default ConfirmationPlanInfo;